const HTML_TAG = /<[^>]*>/g;
const NBSP_ENTITY = /&nbsp;/gi;
const WHITESPACE = /\s+/g;

/** True when a tiptap value carries no text — an untouched editor yields "<p></p>", not "". */
export const isEmptyRichText = (value: string | null | undefined): boolean => {
  if (!value) return true;

  const text = value
    .replace(HTML_TAG, " ")
    .replace(NBSP_ENTITY, " ")
    .replace(WHITESPACE, "");

  return text.length === 0;
};
